import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'dashboard',
        exact: true,
        component: () => import('./components/Dashboard.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Dashboard' }],
            requireAuth:true
        },

    },
    {   
        path: '/cartelas',
        name: 'cartelas-pesquisa',
        component: () => import('./pages/Cartelas/Cartelas.vue'),
        meta: {
            breadcrumb: [{ label: 'Cartelas', to : '/cartelas' }],
        },
    },
    {
        path: `/cartelas/:token`,
        name: 'cartela-detalhes',
        component: () => import('./pages/Cartelas/Cartelas.vue'),
        meta: {
            breadcrumb: [{ label: 'Cartelas', to : '/cartelas' }],
        },
    },
    {
        path: '/ganhadores-sorteio',
        name: 'ganhadores-sorteio-pesquisa',
        component: () => import('./pages/Sorteios/GanhadoresSorteio.vue'),
        meta: {
            breadcrumb: [{ label: 'Ganhadores do sorteio', to : '/ganhadores-sorteio' }],
        },
    },
    {
        path: '/ganhadores-sorteio/:id',
        name: 'ganhadores-sorteio-detalhes',
        component: () => import('./pages/Sorteios/GanhadoresSorteio.vue'),
        meta: {
            breadcrumb: [{ label: 'Ganhadores do sorteio', to : '/ganhadores-sorteio' }],
        },
    },
    {
        path: '/relatorios',
        name: 'relatorios',
        exact: true,
        children: [
            {
                path: '/relatorios/recolhe',
                name:'relatorioRecolhe',
                exact: true,
                component: () => import('./pages/Relatorios/Recolhe.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/recolhe' },
                        { label: 'Recolhe', to : '/relatorios/recolhe' }
                    ],
                    requireAuth:true,
                    requireAccessTwo:true
                },
            },
            {
                path: '/relatorios/posicaorecolhe',
                name:'posicaoRecolhe',
                exact: true,
                component: () => import('./pages/Relatorios/PosicaoRecolhe.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/posicaorecolhe' },
                        { label: 'Posição Recolhe', to : '/relatorios/posicaorecolhe' }
                    ],
                    requireAuth:true,
                    requireAccessTwo:true
                },
            },
            {
                path: '/relatorios/ganhadores',
                name:'ganhadores',
                exact: true,
                component: () => import('./pages/Relatorios/Ganhadores.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/ganhadores' },
                        { label: 'Ganhadores', to : '/relatorios/ganhadores' }
                    ],
                    requireAuth:true,
                    requireAccessOne:true
                },
            },
            {
                path: '/relatorios/sorteio',
                name:'porSorteio',
                exact: true,
                component: () => import('./pages/Relatorios/PorSorteio.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/sorteio' },
                        { label: 'Por Sorteio', to : '/relatorios/sorteio' }
                    ],
                    requireAuth:true,
                    requireAccessFour: true,
                },
            },
            {
                path: '/relatorios/secao',
                name:'porSecao',
                exact: true,
                component: () => import('./pages/Relatorios/PorSecao.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/secao' },
                        { label: 'Por Seção', to : '/relatorios/secao' }
                    ],
                    requireAuth:true,
                    requireAccessFour:true
                },
            },
            {
                path: '/relatorios/estabelecimento',
                name:'porEstabelecimento',
                exact: true,
                component: () => import('./pages/Relatorios/PorEstabelecimento.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/estabelecimento' },
                        { label: 'Por Estabelecimento', to : '/relatorios/estabelecimento' }
                    ],
                    requireAuth:true,
                    requireAccessFour:true
                },
            },
            {
                path: '/relatorios/uso-tv',
                name:'usoTv',
                exact: true,
                component: () => import('./pages/Relatorios/UsoTv.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/uso-tv' },
                        { label: 'Uso da TV', to : '/relatorios/uso-tv' }
                    ],
                    requireAuth:true,
                    // So admin e gestor de regiao: e a mesma lista do backend.
                    requireAccessOne:true
                },
            },
            {
                path: '/relatorios/cartelas',
                name:'cartelas',
                exact: true,
                component: () => import('./pages/Relatorios/Cartelas.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/estabelecimento' },
                        { label: 'Por Estabelecimento', to : '/relatorios/estabelecimento' }
                    ],
                    requireAuth:true,
                    requireAccessFour:true
                },
            },
            {
                path: '/relatorios/acumulados',
                name:'acumulados',
                exact: true,
                component: () => import('./pages/Relatorios/Acumulados.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/acumulados' },
                        { label: 'Relatório de Acumulados', to : '/relatorios/acumulados' }
                    ],
                    requireAuth:true,
                    requireAccessFour:true
                },
            },
            {
                path: '/relatorios/cobranca',
                name:'cobranca',
                exact: true,
                component: () => import('./pages/Relatorios/Cobranca.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Relatórios', to: '/relatorios/cobranca' },
                        { label: 'Cobrança', to : '/relatorios/cobranca' }
                    ],
                    requireAuth:true,
                    requireAccessOne:true
                },
            },
        ],
        meta:{requireAuth:true}
    },
    {
        path: '/usuarios',
        name: 'usuarios',
        exact: true,
        children: [
            {
                path: '/usuarios/admins',
                name:'admins',
                exact: true,
                component: () => import('./pages/Usuarios/Admins.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Usuários', to: '/usuarios/admins' },
                        { label: 'Admins', to : '/usuarios/admins' }
                    ],
                    requireAuth:true,
                    requireAdmin:true
                },
            },
            {
                path: '/usuarios/gestores',
                name:'gestores',
                exact: true,
                component: () => import('./pages/Usuarios/Gestores.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Usuários', to: '/usuarios/gestores' },
                        { label: 'Gestores', to : '/usuarios/gestores' }
                    ],
                    requireAuth:true,
                    requireAdmin:true
                },
            },
            {
                path: '/usuarios/operadores',
                name:'operadores',
                exact: true,
                component: () => import('./pages/Usuarios/Operadores.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Usuários', to: '/usuarios/operadores' },
                        { label: 'Operadores', to : '/usuarios/operadores' }
                    ],
                    requireAuth:true,
                    requireAccessFour:true,
                },
            },
            {
                path: '/usuarios/programadores',
                name:'programadores',
                exact: true,
                component: () => import('./pages/Usuarios/Programadores.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Usuários', to: '/usuarios/programadores' },
                        { label: 'Programadores', to : '/usuarios/programadores' }
                    ],
                    requireAuth:true,
                    requireAdmin:true
                },
            },
            {
                path: '/usuarios/gerente-secao',
                name:'gerenteSecao',
                exact: true,
                component: () => import('./pages/Usuarios/GerenteSecao.vue'),
                meta: {
                    breadcrumb: [
                        { label: 'Usuários', to: '/usuarios/gerente-secao' },
                        { label: 'Gerentes de Seção', to : '/usuarios/gerente-secao' }
                    ],
                    requireAuth:true,
                    requireAccessOne:true
                },
            },
        ],
        meta:{requireAuth:true},
    },
    {
        path: '/regioes',
        name: 'regioes',
        exact: true,
        component: () => import('./pages/Regioes/Regioes.vue'),
        meta: {
            breadcrumb: [{ label: 'Regiões', to : '/regioes' }],
            requireAuth:true,
            requireAdmin: true
        },
    },
    {
        path: '/propagandas',
        name: 'propagandas',
        exact: true,
        component: () => import('./pages/Propagandas/Propagandas.vue'),
        meta: {
            breadcrumb: [{ label: 'Propagandas', to: '/propagandas' }],
            requireAuth: true,
            requireAccessOne: true
        },
    },
    {
        path: '/pagamentos',
        name: 'pagamentos',
        exact: true,
        component: () => import('./pages/Pagamentos/Pagamentos.vue'),
        meta: {
            breadcrumb: [{ label: 'Pagamentos PIX', to: '/pagamentos' }],
            requireAuth: true,
            requireAccessOne: true
        },
    },
    {
        // Token de pagamento e credencial de movimentacao de dinheiro:
        // so admin entra aqui.
        path: '/configuracoes-pagamento',
        name: 'configuracoes-pagamento',
        exact: true,
        component: () => import('./pages/Pagamentos/ConfiguracoesPagamento.vue'),
        meta: {
            breadcrumb: [{ label: 'Configurações de Pagamento', to: '/configuracoes-pagamento' }],
            requireAuth: true,
            requireAdmin: true
        },
    },
    {
        path: '/divulgacao',
        name: 'divulgacao',
        exact: true,
        component: () => import('./pages/Divulgacao/Divulgacao.vue'),
        meta: {
            breadcrumb: [{ label: 'Divulgação', to: '/divulgacao' }],
            requireAuth: true
        },
    },
    {   
        path: '/rotas',
        name: 'rotas',
        exact: true,
        component: () => import('./pages/Rotas/Rotas.vue'),
        meta: {
            breadcrumb: [{ label: 'Rotas', to : '/rotas' }],
            requireAuth:true,
            requireAccessFour:true,
        },
    },
    {   
        path: '/secoes',
        name: 'secoes',
        exact: true,
        component: () => import('./pages/Secoes/Secoes.vue'),
        meta: {
            breadcrumb: [{ label: 'Seções', to : '/secoes' }],
            requireAuth:true,
            requireAccessFour:true,
        },
    },
    {   
        path: '/estabelecimentos',
        name: 'estabelecimentos',
        exact: true,
        component: () => import('./pages/Estabelecimentos/Estabelecimentos.vue'),
        meta: {
            breadcrumb: [{ label: 'Estabelecimentos', to : '/estabelecimentos' }],
            requireAuth:true,
            requireAccessFour:true
        },
    },
    {   
        path: '/partidas',
        name: 'partidas',
        exact: true,
        component: () => import('./pages/Partidas/Partidas.vue'),
        meta: {
            breadcrumb: [{ label: 'Partidas', to : '/partidas' }],
            requireAuth:true,
            requireAccessThree:true,
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue')
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue')
    },
    {
        path: '/:pathMatch(.*)*', 
        name: 'NotFound', 
        component: () => import('./pages/NotFound.vue'),
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 }
    }
})


import store from "./store/store"


router.beforeEach((to, from, next) => {

    const isLogged = store.getters.checkLogged
    const isAdmin = store.getters.isAdmin
    const isGestor = store.getters.isGestor
    const isOperator = store.getters.isOperator
    const isProgramador = store.getters.isProgramador
    const isGerenteSecao = store.getters.isGerenteSecao

    if(to.path === '/' && !isLogged) {
        next('/login')
        return
    }

    if(to.path === '/usuarios' && isLogged || to.path === '/relatorios' && isLogged) {
        next('/NotFound')
        return
    }

    if (to.path === '/' && isLogged && isOperator) {
        next('/relatorios/recolhe')
        return
    }

    if (to.path === '/' && isLogged && isProgramador) {
        next('/partidas')
        return
    }

    if (to.path === '/' && isLogged && isGerenteSecao) {
        next('/secoes')
        return
    }

   

    if (to.meta.requireAuth) {
        if (!isLogged) {
            next('/login')
        } else if (to.meta.requireAdmin && !isAdmin) {
            // Programador tem acesso equivalente ao admin em Regioes --
            // precisa bater com a autorizacao do backend, que aceita os dois.
            // Configuracao de pagamento fica fora: e exclusiva do admin.
            if (to.name == 'regioes' && isProgramador) {
                next()
                return
            }
            next('/access')
        } else if (to.meta.requireAccessOne && !isAdmin && !isGestor) {
            next('/access')
        } else if (to.meta.requireAccessTwo && !isAdmin && !isGestor && !isOperator && !isGerenteSecao) {
            next('/access')
        } else if (to.meta.requireAccessThree && !isProgramador) {
            next('/access')
        } else if (to.meta.requireAccessFour && !isAdmin && !isGestor && !isGerenteSecao) {
            next('/access')
        }
         else {
            next()
        }
    } else {
        next()
    }
})


export default router